<template>
  <div class="col-12" v-html="otherLang"></div>
</template>

<script>
export default {
  props: {
    otherLang: String,
  },
  data: () => ({ }),
  methods: {},
};
</script>
